import { useContext, useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  Divider,
  Fade,
  IconButton,
  Step,
  StepLabel,
  Stepper,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { useNavigate, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import api from "../../api/axios";
import FirmaContent from "../ViewSections/AccordionSections/FirmaContent";
import {
  b64DecodeUnicode,
  formatToTenDigits,
} from "../../Components/helpers/Helpers";
import { ClientContext } from "../../Components/Context/Context";
import fidelitis2 from "../../assets/fidelitis2.png";

import LoadingPage from "../../Components/Common/Loading/LoadingPage";
import NotFoundPage from "../../Components/Common/NotFoundPage";
import { Code, Mail, Send, SendHorizonal, SendIcon } from "lucide-react";
import {
  ArrowBackIos,
  ArrowForward,
  ArrowForwardIos,
  Logout,
} from "@mui/icons-material";
import FormFI from "../Components/FormFI";

const pageContainer = {
  minHeight: "100vh",
  p: 3,
  position: "relative",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
};

const glassCard = {
  width: "100%",
  borderRadius: "8px",
  background: "rgba(255,255,255,0.92)",
  backdropFilter: "blur(6px)",
  boxShadow: "0 10px 25px rgba(0,0,0,0.12)",
};

const sectionBox = {
  width: "100%",
  maxWidth: "900px",
  p: 4,
  mb: 3,
  ...glassCard,
};

const actionButton = {
  borderRadius: "8px",
  px: 3,
  py: 1,
  fontWeight: 600,
};

const otpInput = {
  width: 50,
  "& input": {
    textAlign: "center",
    fontSize: "22px",
    fontWeight: "bold",
    p: "10px",
  },
};

const ClientSign = () => {
  const { clientIsLoggedIn, clientIsLoading, userData, logout } =
    useContext(ClientContext);

  const { user } = userData ?? {};

  const navigate = useNavigate();

  const [searchParams] = useSearchParams();
  const case_id = searchParams.get("id");

  // Estado general del componente
  const [verifiedEmail, setVerifiedEmail] = useState(false);
  const [canSing, setCanSing] = useState(false);
  const [canFillForm, setCanFillForm] = useState(false);
  const [activeTask, setActiveTask] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  const steps = ["Firma del contrato", "Formulario FI"];

  // Dígitos del código OTP
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);

  // Correo ingresado por el usuario
  const [clientEmail, setClientEmail] = useState("");
  const [dataCase, setDataCase] = useState([]);
  const [caseContract, setCaseContract] = useState({});
  const [acceptedContract, setAcceptedContract] = useState("");
  const [updatedCase, setUpdatedCase] = useState("");
  const [temporalToken, setTemporalToken] = useState("");
  const [forceRender, setForceRender] = useState(0);

  const isCaseLoaded = !!dataCase?.id;
  const isUserLoaded = !!user?.id;

  const [bgLoaded, setBgLoaded] = useState(false);

  const getCaseSign = async () => {
    console.log(case_id);
    // PRINCIPAL INFO
    const url = `${process.env.REACT_APP_API_URL}`;

    try {
      const response = await api.post(url + "/sign_contract", { id: case_id });

      console.log(response);
      const {
        // Identificadores Principales
        id,
        case_type_name,
        case_status,
        //Relaciones con Usuarios y Empresas
        company_name,
        clients_relation,
        // Datos del Caso
        case_contract_relation,
        case_asociation_name,
        cases_flow_relation,
        last_task,
        previous_case_statuses_relation,
        cases_notes_relation,
        cases_alerts_relation,
        peritaje,
        apud_acta,
        //  Información del Flujo del Caso
        full_case_status_name,
        full_client_name,
        full_lawyer_name,
        full_office_name,
        //  Relación con Profesionales
        lawyers_relation,
        company_relation,
        types_relation,
        // Fechas y Actualizaciones
        trial_date,
        last_update,
        // Otros Datos
        inss_users,
        client_id,
        transfer_id,
      } = response.data.case[0];

      const formattedNumber = formatToTenDigits(id);

      const sortedStatuses = [...previous_case_statuses_relation].sort(
        (a, b) => a.order - b.order,
      );

      console.log(response);

      setDataCase({
        id: id,
        case_type_name,
        case_id: formattedNumber,
        alerts: cases_alerts_relation,
        client_id,
        notes: cases_notes_relation,
        peritaje: peritaje,
        apud_acta: apud_acta,
        status_name: full_case_status_name,
        task: last_task,
        case_status,
        tasks: response.data.case_tasks,
        completeFlow: sortedStatuses,
        flow: cases_flow_relation,
        last_update,
        transfer_id,
        trial_date,
        clients_relation,
        full_client_name,
        full_lawyer_name,
        full_office_name,
        lawyers_relation,
        company_relation,
        company_name,
      });

      const { case_tasks } = response?.data;

      let ultimo;
      let each;

      if (case_tasks?.length > 0) {
        ultimo = case_tasks[case_tasks?.length - 1];

        for (let index = 0; index < case_tasks?.length; index++) {
          const task = case_tasks[index];

          if (
            task?.cases_flow_relation?.status_name?.toLowerCase().trim() ===
            "formulario fi"
          ) {
            setCanFillForm(true);
            setActiveTask(task);
            break;
          }
        }
      }

      const estado = (ultimo?.cases_flow_relation?.status_name || "")
        .toString()
        .toLowerCase()
        .trim();

      if (
        last_task?.id === ultimo?.id &&
        ultimo?.status == 0 &&
        estado == "firma"
      ) {
        console.log("CAN SIGN");
        setCanSing(true);
      }

      const text = case_contract_relation.contract;
      const htmlText = text.replace(/\n/g, "<br>");

      const tagValues = {
        "#NOMBRE#": `<b>${clients_relation?.name}</b>`,
        "#APELLIDOS#": `<b>${clients_relation?.surname}</b>`,
        "#DIRECCION#": `<b>${clients_relation?.address}</b>`,
        "#PROVINCIA#": `<b>${clients_relation?.province}</b>`,
        "#DNI#": `<b>${clients_relation?.nif}</b>`,
      };

      // Se reemplazan los tags para colocar los datos reales del cliente en el contrato
      const resultReplaceTags = htmlText.replace(
        /#(\w+)#/g,
        (_, key) => tagValues[`#${key}#`] || key,
      );

      var signCurrentStatus;

      if (response?.data?.case_tasks?.length > 0) {
        response.data.case_tasks.forEach((element) => {
          if (element?.config && "firma" in element?.config) {
            setAcceptedContract(b64DecodeUnicode(element?.config.firma));
            signCurrentStatus = element?.config;
          }
        });
      }

      console.log(signCurrentStatus);

      setCaseContract({
        firmaUsuario: signCurrentStatus,
        contract: resultReplaceTags,
        contractTitle: case_contract_relation?.contract_title,
        contractAcceptData: {
          client_name: full_client_name,
          client_nif: clients_relation?.nif,
          company_name: case_contract_relation?.company_relation?.company_name,
          client_ip: response?.data?.ip ? response.data.ip : "0.0.0.0",
        },
      });
    } catch (error) {
      console.error("Error fetching user data:", error); // Mensaje de error más descriptivo
    } finally {
      Swal.close();
    }
    // PRINCIPAL INFO
  };

  // Maneja los cambios en cada input del OTP
  const handleOtpChange = (value, index) => {
    if (/^\d?$/.test(value)) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);

      // Avanza automáticamente al siguiente input
      if (value && index < 5) {
        document.getElementById(`otp-${index + 1}`).focus();
      }
    }
  };

  const nextTask = async (
    config,
    task_status,
    status_desicion,
    message,
    anotherTask,
  ) => {
    console.log(config, task_status, status_desicion, message);
    let ultimo;
    try {
      if (status_desicion === "lastone") {
        console.log("lastone");
        ultimo = dataCase.completeFlow[dataCase.completeFlow.length - 1];
      }

      console.log(ultimo);

      Swal.fire({
        title: "Cargando...",
        html: '<div class="swal-loader"></div>',
        allowOutsideClick: false,
        showConfirmButton: false,
        willOpen: () => {
          Swal.showLoading();
        },
      });

      let nextId;
      let nextTime;

      console.log(dataCase?.completeFlow);
      for (let i = 0; i < dataCase?.completeFlow.length; i++) {
        console.log(i);
        const element = dataCase?.completeFlow;
        if (dataCase?.case_status === element[i].id) {
          console.log(i, "selected");
          console.log(element[i + 1]);
          nextId = element[i + 1]?.id;
          nextTime = element[i + 1]?.status_user_max_delay;
        }
      }

      console.log(nextId);
      const exists = dataCase?.completeFlow?.some((flow) => flow.id === nextId);

      if (!exists) {
        Swal.close();
        Swal.fire({
          title: "Flujo completado",
          text: "No existen más tareas en este caso.",
          icon: "info",
          confirmButtonColor: "#1ab394",
          confirmButtonText: "Aceptar",
        });
        return;
      }

      //  Datos para actualizar la tarea
      const payload = {
        case_status: ultimo?.id
          ? ultimo.id
          : !status_desicion || status_desicion === "next"
            ? nextId
            : dataCase?.task?.task_id,
        case_id: case_id,
        task_id: ultimo?.id ? ultimo.id : nextId,
        status: task_status,
        config: JSON.stringify(config),
        next_config: JSON.stringify({}),
        current_task: dataCase?.task?.task_id,
        update_desicion: status_desicion,
        status_user_max_delay: ultimo?.id ? ultimo.id : nextTime,
        client_name: dataCase?.full_client_name,
      };

      // Si hay mensaje, lo agregamos
      if (message !== "") {
        payload.message = JSON.stringify(message);
      }

      console.log(payload);

      // Ahora generamos el FormData
      const formDataTask = new FormData();
      Object.entries(payload).forEach(([key, value]) => {
        formDataTask.append(key, value);
      });

      const url = `${process.env.REACT_APP_API_URL}`;

      const responseTask = await api.post(url + "/nexttask", formDataTask);

      console.log(responseTask, "tasks actualizadas");

      Swal.close();

      Swal.fire({
        title: "Proceso completado",
        text: "Su firma ha sido registrada exitosamente. Nuestro equipo se comunicará con usted en caso de requerir información adicional o presentar alguna novedad.",
        icon: "success",
        confirmButtonColor: "#1ab394",
        confirmButtonText: "Continuar",
        allowEscapeKey: false,
        allowOutsideClick: false,
      }).then((result) => {
        setUpdatedCase(!updatedCase);
        setForceRender((prev) => prev + 1);
        window.location.reload();
      });
    } catch (err) {
      Swal.close();

      //   Detectamos tipo de error para dar mejor feedback
      let errorMessage = "Ocurrió un error inesperado. Intenta nuevamente.";

      if (err.response) {
        // Error del servidor con respuesta
        errorMessage = err.response.data?.message || "Error en el servidor.";
      } else if (err.request) {
        // El servidor no respondió
        errorMessage = "No hay conexión con el servidor. Revisa tu red.";
      } else {
        // Error en la configuración de la petición
        errorMessage = `Error: ${err.message}`;
      }

      console.error("   Error en nextTask:", err);

      Swal.fire({
        title: "Error",
        text: errorMessage,
        icon: "error",
        confirmButtonColor: "#d33",
        confirmButtonText: "Cerrar",
      });
    }
  };

  // Valida un correo electrónico
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  // Procesa la verificación de información
  const handleClientSignInformation = async () => {
    const otpCode = otp.join("");

    if (!clientEmail?.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Correo requerido",
        text: "Por favor ingresa tu correo electrónico.",
      });
      return;
    }

    const coincidence = await searchCoincidences(clientEmail);
    if (!coincidence) {
      await Swal.fire({
        icon: "warning",
        title: "Correo no autorizado",
        text: "El correo ingresado no coincide con el asignado al expediente. Verifícalo e inténtalo nuevamente.",
        confirmButtonText: "Entendido",
      });
      return;
    }

    if (!validateEmail(clientEmail)) {
      Swal.fire({
        icon: "warning",
        title: "Correo inválido",
        text: "El formato del correo no es correcto.",
      });
      return;
    }

    if (otp.every((d) => d === "")) {
      Swal.fire({
        icon: "warning",
        title: "Código requerido",
        text: "Por favor ingresa el código de verificación.",
      });
      return;
    }

    if (otpCode.length < 6) {
      Swal.fire({
        icon: "warning",
        title: "Código incompleto",
        text: "El código de verificación debe tener 6 dígitos.",
      });
      return;
    }

    console.log(clientEmail);
    console.log(otpCode);

    showLoading("Verificando código...");

    try {
      const res = await api.post(
        `${process.env.REACT_APP_API_URL}/verify-client-otp`,
        {
          email: clientEmail,
          otp: otpCode,
        },
      );

      await Swal.fire({
        icon: "success",
        title: "Código válido",
        allowOutsideClick: false,
        timer: 2000,
        timerProgressBar: true,
        showConfirmButton: false,
        text: res?.data?.message || "Validación completada.",
      }).then((res) => {
        console.log("SE HA VALIDADO EL CODIGO");
        // setSign(true);
        console.log(res);
        window.location.reload();
        // navigate("/expedientes/ver?id=" + case_id);
      });

      console.log("Validación correcta:", res.data);
      return;
    } catch (e) {
      console.error("Error enviando OTP:", e);

      const msg =
        e?.response?.data?.message ||
        e?.response?.data?.errors?.otp?.[0] ||
        "El código ingresado no es válido.";

      Swal.fire({
        icon: "error",
        title: "Código inválido",
        text: msg,
      });

      return;
    }
  };

  const searchCoincidences = async (email) => {
    console.log(email, case_id);
    try {
      Swal.fire({
        title: "Verificando correo",
        text: "Por favor espera...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      const response = await api.post(
        `${process.env.REACT_APP_API_URL}/verify-client-email`,
        { email, case_id },
      );

      console.log(response);

      const { email_match } = response.data;

      Swal.close();
      return !!email_match;
    } catch (error) {
      Swal.close();

      Swal.fire({
        icon: "error",
        title: "Error de verificación",
        text: "No fue posible verificar el correo. Intenta nuevamente.",
      });

      return false;
    }
  };

  const handleResendCode = async () => {
    // Validaciones básicas primero
    if (!clientEmail.trim()) {
      await Swal.fire({
        icon: "warning",
        title: "Correo requerido",
        text: "Por favor ingresa tu correo electrónico.",
      });
      return;
    }

    if (!validateEmail(clientEmail)) {
      await Swal.fire({
        icon: "warning",
        title: "Correo inválido",
        text: "El formato del correo no es correcto.",
      });
      return;
    }

    // Verificar coincidencia usando la función (con loading interno)
    const coincidence = await searchCoincidences(clientEmail);

    console.log(coincidence);

    if (!coincidence) {
      await Swal.fire({
        icon: "warning",
        title: "Correo no autorizado",
        text: "El correo ingresado no coincide con el asignado al expediente.",
        confirmButtonText: "Entendido",
      });
      return;
    } else {
      Swal.fire({
        title: "¡Verificación completa!",
        text: "Por favor espera...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        showConfirmButton: false,
        timer: 2000,
        timerProgressBar: true,
      });
    }

    // Confirmación de reenvío
    const { isConfirmed } = await Swal.fire({
      icon: "question",
      title: "¿Reenviar código?",
      text: "Se enviará un nuevo código de verificación al correo del cliente.",
      showCancelButton: true,
      confirmButtonText: "Sí, reenviar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    });

    if (!isConfirmed) return;

    // Loading envío de código
    Swal.fire({
      title: "Enviando código...",
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => Swal.showLoading(),
    });

    try {
      await api.post(`${process.env.REACT_APP_API_URL}/send-otp-client`, {
        email: clientEmail,
        case_id: Number(case_id),
      });

      Swal.close();

      await Swal.fire({
        icon: "success",
        title: "Código enviado",
        text: "El código ha sido enviado al correo del cliente.",
        confirmButtonColor: "#1ab394",
      });
    } catch (error) {
      Swal.close();
      console.log(error);

      await Swal.fire({
        icon: "error",
        title: "Error al enviar el código",
        text:
          error?.response?.data?.message ||
          "No se pudo enviar el código. Intenta nuevamente.",
      });
    }
  };

  // SweetAlert de carga
  const showLoading = (text = "Procesando...") => {
    Swal.fire({
      title: text,
      allowOutsideClick: false,
      didOpen: () => Swal.showLoading(),
    });
  };

  const cerrarSesion = () => {
    Swal.fire({
      title: "Cerrar sesión",
      icon: "warning",
      html: `<p>¡Estás a punto de salir!</p><b>¿Deseas continuar?</b>`,
      showDenyButton: "Cancelar.",
      confirmButtonText: "Continuar",
      confirmButtonColor: "#1ab394",
      cancelButtonColor: "#d33",
      reverseButtons: true,
    }).then((result) => {
      if (result.isConfirmed) {
        logout();
      }
    });
  };

  // Activa la pantalla cuando carga el componente
  useEffect(() => {
    if (clientIsLoggedIn) {
      getCaseSign();
    }
  }, [forceRender]);

  useEffect(() => {
    if (canFillForm) {
      setActiveStep(1);
    } else if (canSing) {
      setActiveStep(0);
    }
  }, [canFillForm, canSing]);

  const handleStepClick = (index) => {
    if (canNavigateFreely) {
      setActiveStep(index);
      return;
    }

    if (index === 0) {
      setActiveStep(0);
    }
  };

  const handlePrevStep = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleNextStep = () => {
    // Solo permitir avanzar si puede navegar libremente
    if (canNavigateFreely && activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  console.log(dataCase && user && dataCase?.client_id != user?.id);
  console.log(dataCase, user, dataCase?.client_id != user?.id);

  const canNavigateFreely = canFillForm;
  const hasFI = dataCase?.completeFlow?.some(
    (flow) => flow.status_name?.toLowerCase() === "formulario fi",
  );

  //  Estados
  const isLoading = clientIsLoading;
  const isGuest = !clientIsLoggedIn && !isLoading;
  const isClientLogged = clientIsLoggedIn && !isLoading;

  // Mostrar loading SOLO cuando:
  // - el contexto aún carga
  // - o el cliente está logueado pero aún no cargó user/case
  if (
    clientIsLoading ||
    (clientIsLoggedIn && (!isUserLoaded || !isCaseLoaded))
  ) {
    return <LoadingPage isLoading />;
  }

  const isUnauthorized =
    clientIsLoggedIn &&
    dataCase &&
    user &&
    Number(dataCase.client_id) !== Number(user.id);

  if (isUnauthorized) {
    return <NotFoundPage />;
  }

  return (
    <Box
      sx={{
        minHeight: "100vh",
        padding: "20px",
        position: "relative",
        flexDirection: "column",
        alignItems: "center",
        textAlign: "center",
        display: "flex",
      }}>
      <Fade in={bgLoaded} timeout={1000}>
        <img
          src={fidelitis2}
          alt="Fondo Login"
          className="fondoLogin"
          style={{ display: bgLoaded ? "block" : "none" }}
          onLoad={() => setBgLoaded(true)}
        />
      </Fade>

      {/* SI NO ESTÁ LOGUEADO → CARD OTP */}
      {!clientIsLoading && !clientIsLoggedIn && !dataCase?.length > 0 && (
        <Fade in={true} timeout={800}>
          <Box sx={{ ...pageContainer, textAlign: "center" }}>
            <Card sx={{ ...glassCard, maxWidth: 500, p: 3, mt: 4 }}>
              <CardContent>
                <Typography variant="h6" fontWeight={700} mb={1}>
                  Verificación de identidad
                </Typography>

                <Typography variant="body2" color="text.secondary" mb={2}>
                  Ingresa tu correo y el código recibido para continuar
                </Typography>

                <Divider sx={{ mb: 3 }} />

                <TextField
                  label="Correo electrónico"
                  value={clientEmail}
                  fullWidth
                  size="small"
                  onChange={(e) => setClientEmail(e.target.value)}
                  helperText="Sin espacios en blanco"
                />

                <Typography mt={3} fontWeight={500}>
                  Código de verificación
                </Typography>

                <Box display="flex" justifyContent="center" gap={1.5} mt={2}>
                  {otp.map((num, i) => (
                    <TextField
                      key={i}
                      id={`otp-${i}`}
                      value={num}
                      onChange={(e) => handleOtpChange(e.target.value, i)}
                      inputProps={{ maxLength: 1 }}
                      sx={otpInput}
                    />
                  ))}
                </Box>
              </CardContent>

              <CardActions sx={{ justifyContent: "space-between", mt: 1 }}>
                <Button
                  onClick={handleResendCode}
                  startIcon={<Mail />}
                  variant="outlined"
                  sx={actionButton}>
                  Reenviar
                </Button>

                <Button
                  onClick={handleClientSignInformation}
                  endIcon={<ArrowForwardIos />}
                  variant="contained"
                  color="success"
                  sx={actionButton}>
                  Confirmar
                </Button>
              </CardActions>
            </Card>
          </Box>
        </Fade>
      )}

      {/* SI ESTÁ LOGUEADO → CONTRATO */}
      {clientIsLoggedIn && !clientIsLoading && dataCase && (
        <>
          {!caseContract || !caseContract.contract ? (
            <LoadingPage isLoading={true} />
          ) : (
            <Fade in={true} timeout={800}>
              <div>
                <Box sx={sectionBox}>
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center">
                    <Box textAlign="left">
                      <Typography variant="h4" fontWeight={600} mb={1}>
                        ¡Hola {user?.name} {user?.surname}!
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        Te invitamos a firmar la hoja de encargo
                      </Typography>
                    </Box>

                    <Button
                      color="error"
                      variant="outlined"
                      startIcon={<Logout />}
                      onClick={cerrarSesion}
                      sx={actionButton}>
                      Cerrar sesión
                    </Button>
                  </Box>
                </Box>
                <Box
                  sx={{
                    ...sectionBox,
                    display: "flex",
                    alignItems: "center",
                    gap: 2,
                  }}>
                  {/* Flecha izquierda */}
                  <IconButton
                    onClick={handlePrevStep}
                    disabled={activeStep === 0}
                    sx={{
                      opacity: activeStep === 0 ? 0.3 : 1,
                    }}>
                    <ArrowBackIos />
                  </IconButton>

                  {/* Stepper */}
                  <Box sx={{ flex: 1 }}>
                    <Stepper activeStep={activeStep} alternativeLabel>
                      {/* FIRMA → siempre */}
                      <Step completed={activeStep > 0}>
                        <StepLabel
                          onClick={() => handleStepClick(0)}
                          sx={{
                            cursor: "pointer",
                            "& .MuiStepLabel-label": {
                              fontWeight: 600,
                              fontSize: "16px",
                            },
                          }}>
                          Firma del contrato
                        </StepLabel>
                      </Step>

                      {/* FI → solo si existe */}
                      {hasFI && (
                        <Step completed={activeStep > 1}>
                          <StepLabel
                            onClick={() =>
                              canNavigateFreely && handleStepClick(1)
                            }
                            sx={{
                              cursor: canNavigateFreely
                                ? "pointer"
                                : "not-allowed",
                              "& .MuiStepLabel-label": {
                                fontWeight: 600,
                                fontSize: "16px",
                              },
                              opacity: canNavigateFreely ? 1 : 0.5,
                            }}>
                            Formulario FI
                          </StepLabel>
                        </Step>
                      )}
                    </Stepper>
                  </Box>

                  {/* Flecha derecha */}
                  <IconButton
                    onClick={handleNextStep}
                    disabled={
                      !canNavigateFreely || activeStep === steps.length - 1
                    }
                    sx={{
                      opacity:
                        !canNavigateFreely || activeStep === steps.length - 1
                          ? 0.3
                          : 1,
                    }}>
                    <ArrowForwardIos />
                  </IconButton>
                </Box>

                {activeStep === 0 && (
                  <Fade in={true} timeout={800}>
                    <Box sx={{ ...sectionBox, p: 4 }}>
                      <Typography variant="h3">
                        Denominación del caso: {dataCase?.case_type_name}
                      </Typography>
                      <FirmaContent
                        rerender={forceRender}
                        caseContract={caseContract}
                        acceptedContract={acceptedContract}
                        nextTask={nextTask}
                        flagAcceptReject={canSing}
                        setUpdatedCase={setUpdatedCase}
                        updatedCase={updatedCase}
                        dataCase={dataCase}
                      />
                    </Box>
                  </Fade>
                )}
                {activeStep === 1 && canFillForm && (
                  <Fade in={true} timeout={800}>
                    <Box sx={{ ...sectionBox, p: 4 }}>
                      <FormFI
                        caseId={case_id}
                        nextTask={nextTask}
                        dataCase={dataCase}
                        setUpdatedCase={setUpdatedCase}
                        updatedCase={updatedCase}
                        activeTask={activeTask}
                      />
                    </Box>
                  </Fade>
                )}
              </div>
            </Fade>
          )}
        </>
      )}
    </Box>
  );
};

export default ClientSign;
